<template>
  <el-menu
    class="el-menu-demo"
    mode="horizontal"
    @select="handleSelect"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
  >
    <el-menu-item index="1">
      <router-link :to="{ path: '/' }" replace>首页</router-link>
    </el-menu-item>
    <el-menu-item index="2">
      <router-link :to="{ path: '/main' }" replace>选股</router-link>
    </el-menu-item>
    <!-- <el-submenu index="2">
      <template slot="title">选股</template>
      <el-menu-item index="2-1">选项1</el-menu-item>
      <el-menu-item index="2-2">选项2</el-menu-item>
      <el-menu-item index="2-3">选项3</el-menu-item>
      <el-submenu index="2-4">
        <template slot="title">选项4</template>
        <el-menu-item index="2-4-1">选项1</el-menu-item>
        <el-menu-item index="2-4-2">选项2</el-menu-item>
        <el-menu-item index="2-4-3">选项3</el-menu-item>
      </el-submenu> 
    </el-submenu>-->
    <!-- <el-menu-item index="3" disabled>购买</el-menu-item> -->
    <el-menu-item index="3">
      <router-link :to="{ path: '/we' }" replace>我们</router-link>
    </el-menu-item>
    <el-menu-item index="4" v-if="usernameInSession == null || usernameInSession.length == 0"
      ><router-link :to="{ path: '/login' }" replace
        >登录</router-link
      ></el-menu-item>
    <el-submenu index="5" float="right" v-else>
        <!-- <router-link :to="{ path: '/profile' }" replace
        >{{usernameInSession}}</router-link> -->
        <template slot="title">{{usernameInSession}} ({{memberLevel}})</template>
        <el-menu-item index="6-1" align="center">我的设置</el-menu-item>
        <el-menu-item index="6-2" align="center">会员升级</el-menu-item>
        <el-menu-item index="6-3" align="center" @click="exitAccount">退出账号</el-menu-item>
     </el-submenu>
  </el-menu>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: "1",
      usernameInSession: "",
      memberLevel:""
    };
  },
  created() {
    this.usernameInSession = sessionStorage.getItem("username");
    this.memberLevel = sessionStorage.getItem("userlevel");
    console.log("create username: --------------" + this.usernameInSession);
  },

  mounted() {
    this.usernameInSession = sessionStorage.getItem("username");
    console.log("mount username: --------------" + this.usernameInSession);
    this.memberLevel = sessionStorage.getItem("userlevel");
    console.log("mount userlevel: --------------" + this.memberLevel);
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    exitAccount(){
      this.$store.dispatch("UserLogout");
      //this.$alert("账号已退出！");
      this.usernameInSession = "";
      this.memberLevel="";
      //window.location.reload();
    }
  }
};
</script>
<style>
.el-menu-item {
  padding: 0 100px;
  font-size: 20px;
  border: none;
  border-bottom-color:#545c64!important;
}
</style>




// WEBPACK FOOTER //
// src/components/NavHeader.vue